export const personalData = [

    {
        title: "Pet a dog",
        description: 'Add this to every day of your calendar. Do it. Trust me.',
        type: "",
        id: "12",
        image: "./Pet_a_dog.jpeg"
    },
    {
        title: "Go for a walk",
        description: 'These boots were made for walking, and that\'s just what they\'ll do. Okay maybe don\'t wear boots.',
        type: "outdoor",
        id: "1",
        image: "./Go_for_a_walk.jpeg"
    },  
    {
        title: "Read a book",
        description: 'So what if it\'s 50 Shades of Grey? Enjoy every cringey sentence.',
        type: "",
        id: "10",
        image: "./Read_a_book.jpeg"
    },
    {
        title: "Paint",
        description: 'We can\'t all be Leonardo da Vincis\', but we can be Picassos\'.',
        type: "",
        id: "9",
        image: "./Paint.jpeg"
    }
];
